import authService from './AuthService';
import { BulkOperationProgress } from '../typings';
import { REACT_APP_IDENTITY_API_BASE_URL } from '../constants';

class BulkProgressService {
    async streamProgress(
        operationId: string,
        onProgress: (data: BulkOperationProgress) => void
    ): Promise<void> {
        const user = await authService.getUser();
        const token = user?.access_token;
        if (!token) return;

        const url = `${REACT_APP_IDENTITY_API_BASE_URL}/v1/users/actions/bulk-progress/${operationId}`;

        try {
            const response = await fetch(url, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!response.ok || !response.body) return;

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const data: BulkOperationProgress = JSON.parse(line.slice(6));
                            onProgress(data);
                        } catch { /* skip malformed events */ }
                    }
                }
            }
        } catch {
            /* connection closed or error — operation may have completed */
        }
    }
}

const bulkProgressService = new BulkProgressService();
export default bulkProgressService;
